/* =========================================================
   Install Hub (ihub) - Shared JS
   - Storefront API fetch metaobjects: install_models
   - Build brand UI + render cards
   - 2nd-level grouping: series (inside a brand)
   - Click card -> load products-only section into detail panel
   ========================================================= */

(function () {
  var TYPE = 'install_models';
  var PAGE_SIZE = 250;
  var MAX_PAGES = 20;
  var DEFAULT_VERSION = '2024-10';

  function toStr(v) { return v == null ? '' : String(v); }
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function boolAttr(root, name, fallback) {
    var v = root.getAttribute(name);
    if (v == null) return !!fallback;
    v = String(v).toLowerCase();
    return (v === '' || v === 'true' || v === '1' || v === 'yes' || v === 'on');
  }

  function handleize(s) {
    s = toStr(s).trim().toLowerCase();
    s = s.replace(/&/g, ' and ');
    s = s.replace(/['"]/g, '');
    s = s.replace(/[^a-z0-9]+/g, '-');
    s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');
    return s || 'other';
  }

  function scoreLabel(label) {
    // prefer "Apple" over "apple", prefer "POCO" over "Poco"
    var s = 0;
    for (var i = 0; i < label.length; i++) {
      var c = label.charCodeAt(i);
      if (c >= 65 && c <= 90) s += 2; // A-Z
    }
    return s + label.length * 0.01;
  }

  // ----------------------------
// Brand UI content (no icons)
// ----------------------------

function ensureLabelOnly(btn) {  var labelEl = btn.querySelector('.ihub__label');
  if (!labelEl) {
    var txt = btn.textContent || '';
    btn.textContent = '';
    labelEl = document.createElement('span');
    labelEl.className = 'ihub__label';
    labelEl.textContent = txt;
    btn.appendChild(labelEl);
  }
  return labelEl;
}

function setBtnContent(btn, brandKey, labelText) {
  btn.type = 'button';
  btn.setAttribute('data-brand', brandKey);
  var labelEl = ensureLabelOnly(btn);
  labelEl.textContent = labelText;
}

// ----------------------------
// Storefront API
// ----------------------------

  function postGraphQL(root, query, variables) {
    var token = toStr(root.dataset.sfToken || '').trim();
    var version = toStr(root.dataset.sfVersion || DEFAULT_VERSION).trim() || DEFAULT_VERSION;
    if (!token) return Promise.reject(new Error('Missing Storefront API token'));

    var url = '/api/' + version + '/graphql.json';
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (json) {
      if (json && json.errors && json.errors.length) {
        throw new Error(json.errors[0].message || 'GraphQL error');
      }
      return json.data;
    });
  }

  function fieldsToMap(fields) {
    var map = Object.create(null);
    (fields || []).forEach(function (f) {
      if (!f || !f.key) return;
      map[f.key] = f;
    });
    return map;
  }

  function getFieldValue(fmap, key) {
    var f = fmap && fmap[key];
    return f && f.value != null ? toStr(f.value) : '';
  }

  function getImageUrlFromField(fmap, key) {
    var f = fmap && fmap[key];
    if (!f) return '';
    // If schema supports reference.image.url
    if (f.reference && f.reference.__typename) {
      if (f.reference.__typename === 'MediaImage' && f.reference.image && f.reference.image.url) {
        return toStr(f.reference.image.url);
      }
      if (f.reference.__typename === 'GenericFile' && f.reference.url) {
        return toStr(f.reference.url);
      }
    }
    // Fallback: if value is already a URL string
    var v = toStr(f.value || '').trim();
    if (v.indexOf('http://') === 0 || v.indexOf('https://') === 0) return v;
    return '';
  }

  function fetchAllModels(root) {
    var QUERY_WITH_REF =
      'query GetModels($first:Int!, $after:String){' +
        'metaobjects(type:"' + TYPE + '", first:$first, after:$after){' +
          'edges{ cursor node{ id handle type fields{ key value reference{ __typename ' +
            '... on MediaImage{ image{ url altText width height } } ' +
            '... on GenericFile{ url } ' +
          '} } } }' +
          'pageInfo{ hasNextPage endCursor }' +
        '}' +
      '}';

    var QUERY_SIMPLE =
      'query GetModels($first:Int!, $after:String){' +
        'metaobjects(type:"' + TYPE + '", first:$first, after:$after){' +
          'edges{ cursor node{ id handle type fields{ key value } } }' +
          'pageInfo{ hasNextPage endCursor }' +
        '}' +
      '}';

    function runQuery(queryStr) {
      var all = [];
      var after = null;
      var page = 0;

      function loop() {
        page++;
        if (page > MAX_PAGES) return Promise.resolve(all);

        return postGraphQL(root, queryStr, { first: PAGE_SIZE, after: after }).then(function (data) {
          var conn = data && data.metaobjects;
          var edges = (conn && conn.edges) || [];
          var pi = (conn && conn.pageInfo) || {};
          edges.forEach(function (e) {
            if (e && e.node) all.push(e.node);
          });
          after = pi.endCursor || null;
          if (pi.hasNextPage) return loop();
          return all;
        });
      }

      return loop();
    }

    // Try reference query first; fallback to simple if schema errors
    return runQuery(QUERY_WITH_REF).catch(function () {
      return runQuery(QUERY_SIMPLE);
    });
  }

  // ----------------------------
  // Render helpers
  // ----------------------------

  function pluralizeModel(n) { return n === 1 ? 'model' : 'models'; }

  function createBtnFromTemplate(tpl) {
    if (tpl && tpl.content && tpl.content.firstElementChild) {
      return tpl.content.firstElementChild.cloneNode(true);
    }
    var b = document.createElement('button');
    b.type = 'button';
    return b;
  }

  function createCard(model, showBrand, showDevice) {
    var a = document.createElement('a');
    a.className = 'ihub__card';
    a.setAttribute('role', 'listitem');
    a.href = model.url || '#';
    a.setAttribute('data-url', model.url || '');
    a.setAttribute('data-title', model.title || '');
    a.setAttribute('data-brand', model.brandKey || '');
    a.setAttribute('data-series', model.seriesKey || '');
    a.setAttribute('data-sort', String(model.sort || 9999));
    a.setAttribute('data-search', model.searchText || '');

    if (model.imageUrl) {
      var media = document.createElement('div');
      media.className = 'ihub__cardMedia';
      var img = document.createElement('img');
      img.className = 'ihub__cardImg';
      img.loading = 'lazy';
      img.alt = model.title || '';
      img.src = model.imageUrl;
      media.appendChild(img);
      a.appendChild(media);
    }

    var body = document.createElement('div');
    body.className = 'ihub__cardBody';

    var t = document.createElement('div');
    t.className = 'ihub__cardTitle';
    t.textContent = model.title || '';
    body.appendChild(t);

    if (showBrand && model.brandLabel) {
      var b = document.createElement('div');
      b.className = 'ihub__cardBrand';
      b.textContent = model.brandLabel;
      body.appendChild(b);
    }

    if (showDevice && model.deviceType) {
      var d = document.createElement('div');
      d.className = 'ihub__cardBrand';
      d.textContent = model.deviceType;
      body.appendChild(d);
    }

    a.appendChild(body);
    return a;
  }

  function createGroup(title) {
    var wrap = document.createElement('section');
    wrap.className = 'ihub__group';

    var h = document.createElement('h3');
    h.className = 'ihub__groupTitle';
    h.textContent = title || '';
    wrap.appendChild(h);

    var grid = document.createElement('div');
    grid.className = 'ihub__grid';
    grid.setAttribute('role', 'list');
    wrap.appendChild(grid);

    return { wrap: wrap, grid: grid };
  }

  // ----------------------------
  // Detail panel (products-only)
  // ----------------------------

  function initDetailBehavior(root) {
    var detail = qs(root, '.ihub__detail');
    var detailInner = qs(root, '.ihub__detailInner');
    var detailClose = qs(root, '.ihub__detailClose');
    var currentUrl = null;

    function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

    // iOS-safe scroll lock (only used on mobile overlay)
    var scrollLock = { y: 0, locked: false };
    function lockScroll() {
      if (scrollLock.locked) return;
      scrollLock.y = window.scrollY || 0;
      document.documentElement.setAttribute('data-ihub-lock', 'true');
      document.body.style.position = 'fixed';
      document.body.style.top = (-scrollLock.y) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      scrollLock.locked = true;
    }
    function unlockScroll() {
      if (!scrollLock.locked) return;
      document.documentElement.removeAttribute('data-ihub-lock');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollLock.y || 0);
      scrollLock.locked = false;
    }

    function resetDetail() {
      currentUrl = null;
      if (detailClose) detailClose.textContent = 'Back';
      if (detailInner) {
        detailInner.innerHTML =
          '<div class="ihub__detailPlaceholder">Select a model to view available products.</div>';
      }
      qsa(root, '.ihub__card.is-active').forEach(function (c) { c.classList.remove('is-active'); });
    }

    function closeDetail() {
      root.classList.remove('is-detail-open');
      if (!isDesktop()) unlockScroll();
      resetDetail();
    }

    function loadGuide(url, userInitiated) {
      if (!detail || !detailInner || !url) return;
      if (currentUrl === url) return;
      currentUrl = url;

      if (!isDesktop()) {
        lockScroll();
        root.classList.add('is-detail-open');
      } else {
        root.classList.remove('is-detail-open');
      }

      detailInner.innerHTML = '<div class="ihub__detailLoading">Loading…</div>';

      var sep = url.indexOf('?') >= 0 ? '&' : '?';
      fetch(url + sep + 'section_id=install-guide-products-only', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          detailInner.innerHTML = html;

          // If injected section contains a .page-width wrapper, remove it to fit in the panel.
          var pw = detailInner.querySelector('.page-width');
          if (pw) pw.classList.remove('page-width');

          if (!isDesktop()) {
            detail.scrollTop = 0;
          } else if (userInitiated) {
            detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        })
        .catch(function () {
          detailInner.innerHTML = '<div class="ihub__detailError">Failed to load. Please try again later.</div>';
        });
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest('.ihub__card');
      if (!a) return;

      e.preventDefault();

      qsa(root, '.ihub__card').forEach(function (c) { c.classList.remove('is-active'); });
      a.classList.add('is-active');

      var title = a.getAttribute('data-title') || '';
      if (!isDesktop() && detailClose) {
        detailClose.textContent = title ? ('Back · ' + title) : 'Back';
      }

      loadGuide(a.getAttribute('data-url') || a.getAttribute('href'), true);
    });

    if (detailClose) detailClose.addEventListener('click', closeDetail);

    // On viewport change, ensure overlay isn't stuck
    var mq = window.matchMedia('(min-width: 990px)');
    if (mq && mq.addEventListener) {
      mq.addEventListener('change', function () {
        if (isDesktop()) {
          unlockScroll();
          root.classList.remove('is-detail-open');
        }
      });
    }

    return { resetDetail: resetDetail, closeDetail: closeDetail };
  }

  // ----------------------------
  // Main init
  // ----------------------------

  function initRoot(root) {
    if (!root || root.getAttribute('data-ihub-initialized') === 'true') return;
    root.setAttribute('data-ihub-initialized', 'true');

    var tabsWrap = qs(root, '.ihub__tabs');
    var brandsWrap = qs(root, '.ihub__brands');
    var subtabsWrap = qs(root, '.ihub__subtabs');
    var listWrap = qs(root, '.ihub__list');

    var tplTab = qs(root, '#ihub-tab-template');
    var tplBrand = qs(root, '#ihub-brand-template');
    var tplSubtab = qs(root, '#ihub-subtab-template');

    var search = qs(root, '.ihub__searchInput');
    var clearBtn = qs(root, '.ihub__clear');
    var countEl = qs(root, '.ihub__count');
    var emptyEl = qs(root, '.ihub__empty');
    var allLabel = toStr(root.dataset.allLabel || 'All').trim() || 'All';
    var noResults = toStr(root.dataset.noResults || 'No matching results found.').trim();
    var loadFailed = toStr(root.dataset.loadFailed || 'Load failed.').trim();

    var showBrandOnCard = boolAttr(root, 'data-show-brand', false);
    var showDeviceOnCard = boolAttr(root, 'data-show-device', false);

    var detailApi = initDetailBehavior(root);

    var state = { brand: '__all__', series: '__all__', q: '' };
    var models = [];
    var brands = []; // [{key,label}]
    var seriesByBrand = Object.create(null); // brandKey -> [{key,label}]
    var seriesCountByBrand = Object.create(null); // brandKey -> {seriesKey: count}

    function setCount(n) {
      if (countEl) countEl.textContent = n ? (n + ' ' + pluralizeModel(n)) : '';
    }

    function setEmpty(show) {
      if (!emptyEl) return;
      emptyEl.hidden = !show;
      if (show) emptyEl.textContent = noResults;
    }

    function clearActiveIn(container, sel) {
      qsa(container, sel).forEach(function (el) { el.classList.remove('is-active'); });
    }

    function ensureAllBtn(container, cls, dataName) {
      var btn = qs(container, '.' + cls + '[data-' + dataName + '="__all__"]');
      if (btn) return btn;
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = cls + ' is-active';
      btn.setAttribute('data-' + dataName, '__all__');
      var span = document.createElement('span');
      span.className = 'ihub__label';
      span.textContent = allLabel;
      btn.appendChild(span);
      container.insertBefore(btn, container.firstChild);
      return btn;
    }

    function rebuildBrandsUI() {
      if (!tabsWrap || !brandsWrap) return;

      // Keep the first All button already in markup, then remove others
      qsa(tabsWrap, '.ihub__tab').slice(1).forEach(function (n) { n.remove(); });
      qsa(brandsWrap, '.ihub__brand').slice(1).forEach(function (n) { n.remove(); });

      // Set All button label/icon
      var tabAll = qs(tabsWrap, '.ihub__tab[data-brand="__all__"]');
      var brandAll = qs(brandsWrap, '.ihub__brand[data-brand="__all__"]');
      if (tabAll) setBtnContent(tabAll, '__all__', allLabel);
      if (brandAll) setBtnContent(brandAll, '__all__', allLabel);

      brands.forEach(function (b) {
        var t = createBtnFromTemplate(tplTab);
        t.className = 'ihub__tab';
        setBtnContent(t, b.key, b.label);
        tabsWrap.appendChild(t);

        var m = createBtnFromTemplate(tplBrand);
        m.className = 'ihub__brand';
        setBtnContent(m, b.key, b.label);
        brandsWrap.appendChild(m);
      });

      function bindBrandClicks(btns) {
        btns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            setActiveBrand(btn.getAttribute('data-brand') || '__all__');
          });
        });
      }
      bindBrandClicks(qsa(tabsWrap, '.ihub__tab'));
      bindBrandClicks(qsa(brandsWrap, '.ihub__brand'));
    }

    function rebuildSeriesUI() {
      if (!subtabsWrap) return;

      // show only when brand != all and series count >= 2 and no searching
      var brandKey = state.brand;
      var list = seriesByBrand[brandKey] || [];
      var need = (brandKey !== '__all__' && list.length >= 2 && !state.q.trim());

      subtabsWrap.hidden = !need;
      if (!need) return;

      // Clear existing except the first (All)
      qsa(subtabsWrap, '.ihub__subtab').slice(1).forEach(function (n) { n.remove(); });

      // Ensure All exists + label
      var allBtn = ensureAllBtn(subtabsWrap, 'ihub__subtab', 'series');
      allBtn.classList.toggle('is-active', state.series === '__all__');
      var allLabelEl = allBtn.querySelector('.ihub__label');
      if (allLabelEl) allLabelEl.textContent = allLabel;

      list.forEach(function (s) {
        var b = createBtnFromTemplate(tplSubtab);
        b.className = 'ihub__subtab';
        b.setAttribute('data-series', s.key);
        var lab = b.querySelector('.ihub__label');
        if (!lab) {
          lab = document.createElement('span');
          lab.className = 'ihub__label';
          b.appendChild(lab);
        }
        lab.textContent = s.label;
        b.classList.toggle('is-active', state.series === s.key);
        subtabsWrap.appendChild(b);
      });

      qsa(subtabsWrap, '.ihub__subtab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setActiveSeries(btn.getAttribute('data-series') || '__all__');
        });
      });
    }

    function setActiveBrand(brandKey) {
      state.brand = brandKey || '__all__';
      state.series = '__all__'; // reset series when brand changes

      clearActiveIn(tabsWrap, '.ihub__tab');
      clearActiveIn(brandsWrap, '.ihub__brand');

      var t = tabsWrap && qs(tabsWrap, '.ihub__tab[data-brand="' + state.brand + '"]');
      var b = brandsWrap && qs(brandsWrap, '.ihub__brand[data-brand="' + state.brand + '"]');
      if (t) t.classList.add('is-active');
      if (b) b.classList.add('is-active');

      if (detailApi) {
        detailApi.closeDetail();
        detailApi.resetDetail();
      }

      render();
    }

    function setActiveSeries(seriesKey) {
      state.series = seriesKey || '__all__';
      qsa(subtabsWrap, '.ihub__subtab').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-series') === state.series);
      });

      if (detailApi) {
        detailApi.closeDetail();
        detailApi.resetDetail();
      }

      render();
    }

    function sortModels(a, b) {
      if (a.sort !== b.sort) return a.sort - b.sort;
      return (a.title || '').toLowerCase().localeCompare((b.title || '').toLowerCase());
    }

    function isOtherSeries(s) {
      if (!s) return false;
      var key = (s.key || '').toLowerCase();
      var label = (s.label || '').toLowerCase().trim();
      return key === 'other' || label === 'other';
    }

    function seriesSort(a, b) {
      var ao = isOtherSeries(a);
      var bo = isOtherSeries(b);
      if (ao && !bo) return 1;   // a 是 Other -> 往后
      if (!ao && bo) return -1;  // b 是 Other -> a 往前
      return (a.label || '').toLowerCase().localeCompare((b.label || '').toLowerCase());
    }

    function renderFlat(list) {
      listWrap.innerHTML = '';
      var grid = document.createElement('div');
      grid.className = 'ihub__grid';
      grid.setAttribute('role', 'list');

      var frag = document.createDocumentFragment();
      list.forEach(function (m) {
        frag.appendChild(createCard(m, showBrandOnCard, showDeviceOnCard));
      });
      grid.appendChild(frag);
      listWrap.appendChild(grid);
    }

    function renderGroupedBySeries(list, brandKey) {
      listWrap.innerHTML = '';

      var groups = Object.create(null);
      var order = [];

      list.forEach(function (m) {
        var sk = m.seriesKey || 'other';
        if (!groups[sk]) {
          groups[sk] = [];
          order.push(sk);
        }
        groups[sk].push(m);
      });

      // order by series label
      order.sort(function (ka, kb) {
      // 强制 Other 在最后
      if (ka === 'other' && kb !== 'other') return 1;
      if (ka !== 'other' && kb === 'other') return -1;

      var la = (groups[ka][0] && groups[ka][0].seriesLabel) || '';
      var lb = (groups[kb][0] && groups[kb][0].seriesLabel) || '';
      return la.toLowerCase().localeCompare(lb.toLowerCase());
      });


      var frag = document.createDocumentFragment();
      order.forEach(function (sk) {
        var arr = groups[sk] || [];
        arr.sort(sortModels);

        var title = (arr[0] && arr[0].seriesLabel) || 'Other';
        var g = createGroup(title);

        var cardsFrag = document.createDocumentFragment();
        arr.forEach(function (m) {
          cardsFrag.appendChild(createCard(m, showBrandOnCard, showDeviceOnCard));
        });
        g.grid.appendChild(cardsFrag);
        frag.appendChild(g.wrap);
      });

      listWrap.appendChild(frag);
    }

    function render() {
      var q = toStr(state.q || '').trim().toLowerCase();
      var brandKey = state.brand || '__all__';
      var seriesKey = state.series || '__all__';

      var list = models.filter(function (m) {
        var okBrand = (brandKey === '__all__') || (m.brandKey === brandKey);
        if (!okBrand) return false;

        var okSeries = (seriesKey === '__all__') || (m.seriesKey === seriesKey);
        if (!okSeries) return false;

        if (!q) return true;
        return (m.searchText || '').toLowerCase().indexOf(q) !== -1;
      });

      setCount(list.length);
      setEmpty(list.length === 0);

      // Search mode: flat list is clearer
      if (q) {
        if (subtabsWrap) subtabsWrap.hidden = true;
        list.sort(sortModels);
        renderFlat(list);
        return;
      }

      // Brand mode: if brand selected and has >=2 series -> grouped view
      if (brandKey !== '__all__' && (seriesByBrand[brandKey] || []).length >= 2 && seriesKey === '__all__') {
        rebuildSeriesUI();
        renderGroupedBySeries(list, brandKey);
        return;
      }

      // Single series selected OR no series: flat list
      rebuildSeriesUI();
      list.sort(sortModels);
      renderFlat(list);
    }

    // Search binding
    if (search) {
      var onSearchChange = function () {
        state.q = search.value || '';
        if (clearBtn) clearBtn.hidden = !state.q;
        if (state.q) state.series = '__all__'; // search overrides series
        if (detailApi) {
          detailApi.closeDetail();
          detailApi.resetDetail();
        }
        render();
      };
      search.addEventListener('input', onSearchChange);
      search.addEventListener('search', onSearchChange);
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (!search) return;
        search.value = '';
        state.q = '';
        clearBtn.hidden = true;
        render();
      });
    }

    // Fetch + build data
    fetchAllModels(root).then(function (nodes) {
      var brandMap = Object.create(null);

      nodes.forEach(function (node) {
        var fmap = fieldsToMap(node.fields);

        var brandLabel = getFieldValue(fmap, 'brand').trim();
        if (!brandLabel) return;

        var title = getFieldValue(fmap, 'title').trim() || toStr(node.handle || '').trim();
        if (!title) return;

        var deviceType = getFieldValue(fmap, 'device_type').trim();
        var seriesLabel =
          getFieldValue(fmap, 'series').trim() ||
          getFieldValue(fmap, 'family').trim() ||
          '';

        var sort = parseInt(getFieldValue(fmap, 'sort').trim() || '9999', 10);
        if (isNaN(sort)) sort = 9999;

        var handle = toStr(node.handle || '').trim();
        var url = getFieldValue(fmap, 'url').trim();
        if (!url && handle) url = '/pages/install-models/' + handle;

        var imageUrl =
          getImageUrlFromField(fmap, 'image') ||
          getImageUrlFromField(fmap, 'model_image') ||
          '';

        var brandKey = handleize(brandLabel);
        var seriesKey = seriesLabel ? handleize(seriesLabel) : 'other';

        var searchText = (brandLabel + ' ' + title + ' ' + deviceType + ' ' + seriesLabel).toLowerCase();

        models.push({
          id: node.id,
          handle: handle,
          url: url,
          title: title,
          sort: sort,
          brandKey: brandKey,
          brandLabel: brandLabel,
          deviceType: deviceType,
          seriesKey: seriesKey,
          seriesLabel: seriesLabel || 'Other',
          imageUrl: imageUrl,
          searchText: searchText
        });

        // brand label unify
        if (!brandMap[brandKey]) {
          brandMap[brandKey] = { key: brandKey, label: brandLabel, score: scoreLabel(brandLabel) };
        } else {
          var sc = scoreLabel(brandLabel);
          if (sc > brandMap[brandKey].score) {
            brandMap[brandKey].label = brandLabel;
            brandMap[brandKey].score = sc;
          }
        }

        // series aggregation
        if (!seriesByBrand[brandKey]) seriesByBrand[brandKey] = [];
        if (!seriesCountByBrand[brandKey]) seriesCountByBrand[brandKey] = Object.create(null);
        seriesCountByBrand[brandKey][seriesKey] = (seriesCountByBrand[brandKey][seriesKey] || 0) + 1;

        // store series label
        var exists = seriesByBrand[brandKey].some(function (s) { return s.key === seriesKey; });
        if (!exists) {
          seriesByBrand[brandKey].push({ key: seriesKey, label: seriesLabel || 'Other' });
        }
      });

      brands = Object.keys(brandMap).map(function (k) { return brandMap[k]; });

function parseBrandOrder(root) {
  var raw = toStr(root.dataset.brandOrder || '').trim();
  if (!raw) return [];
  return raw
    .split('|')
    .map(function (s) { return (s || '').trim(); })
    .filter(function (s) { return !!s; })
    .map(function (s) { return handleize(s); })
    .filter(function (k) { return k && k !== '__all__'; });
}


var orderList = parseBrandOrder(root);
var orderMap = Object.create(null);
orderList.forEach(function (k, idx) {
  if (orderMap[k] == null) orderMap[k] = idx;
});

brands.sort(function (a, b) {
  var ak = a.key, bk = b.key;

  var ai = orderMap[ak];
  var bi = orderMap[bk];
  var hasA = ai != null;
  var hasB = bi != null;

  // 1) 你写了顺序的：按你写的排
  if (hasA && hasB) return ai - bi;
  if (hasA && !hasB) return -1;
  if (!hasA && hasB) return 1;

  // 2) 没写到的：Other 默认放最后（除非你在顺序里写了 Other）
  if (ak === 'other' && bk !== 'other') return 1;
  if (ak !== 'other' && bk === 'other') return -1;

  // 3) 最后再按字母
  return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
});


      // sort series per brand
      Object.keys(seriesByBrand).forEach(function (bk) {
        seriesByBrand[bk].sort(seriesSort);
      });

      models.sort(sortModels);

      rebuildBrandsUI();
      root.classList.add('is-loaded');

      setActiveBrand('__all__');
    }).catch(function () {
      root.classList.add('is-loaded');
      if (listWrap) {
        listWrap.innerHTML = '<div class="ihub__detailError">' + loadFailed + '</div>';
      }
      setCount(0);
      setEmpty(true);
    });
  }

  function initAll(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-ihub-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
